import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\UpdateChiftExternalReferenceController::__invoke
* @see app/Http/Controllers/Person/UpdateChiftExternalReferenceController.php
* @route '/api/person/{person}/chift/link'
*/
const UpdateChiftExternalReferenceController = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateChiftExternalReferenceController.url(args, options),
    method: 'post',
})

UpdateChiftExternalReferenceController.definition = {
    methods: ["post"],
    url: '/api/person/{person}/chift/link',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Person\UpdateChiftExternalReferenceController::__invoke
* @see app/Http/Controllers/Person/UpdateChiftExternalReferenceController.php
* @route '/api/person/{person}/chift/link'
*/
UpdateChiftExternalReferenceController.url = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { person: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { person: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            person: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        person: typeof args.person === 'object'
        ? args.person.id
        : args.person,
    }

    return UpdateChiftExternalReferenceController.definition.url
            .replace('{person}', parsedArgs.person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\UpdateChiftExternalReferenceController::__invoke
* @see app/Http/Controllers/Person/UpdateChiftExternalReferenceController.php
* @route '/api/person/{person}/chift/link'
*/
UpdateChiftExternalReferenceController.post = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateChiftExternalReferenceController.url(args, options),
    method: 'post',
})

export default UpdateChiftExternalReferenceController